<template>
    <div class="ServicesPage">
		<Services />
	</div>
</template>

<script>
import Services from '@/components/Services/Services'

export default {
	name: 'ServicesPage',
	components: {
		Services
	}
}
</script>

<style lang="scss" scoped>

.ServicesPage {
	padding-top: 120px;
	background: $blue;

	@media screen and (min-width: 1440px) {
		padding-top: 80px;
	}
}

</style>
